module.exports = __webpack_public_path__ + "img/date.5339e64c.svg";